import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import defaultImage from '../../images/default.gif';
import locationimg from '../../images/location.svg';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import logo from "../../images/KlickExLogo_w.png";
import imglogout from "../../images/logout.png";
import profileImg from "../../images/profileImg.png";
import SaveIcon from '@material-ui/icons/ArrowDropDown';
import '../../stylesheet/hoverdropdown.css';
import IdleTimeOutModal from './idleModal.jsx';
import moment from "moment";

const styles = {
    activeStyle: {
        backgroundColor: "#fff",
        boxShadow: "0 0px 0px 0px rgba(42, 81, 148, 0.2), 0 16px 16px -11px rgba(42, 81, 148, 0.6)",
        border: "1px solid #f5f5f5",
        borderBottom: "2px solid #333",
    }
}
const mapStateToProps = state =>
({
    profileState: state.getProfileReducer.profileState,
    display: state.getProfileReducer.display,
    optionState: state.selectedTabReducer.selectedTabReducer,
})

const mapDispatchToProps = dispatch =>
({
    fetchProfileState(history) {
        dispatch(
            actions.getProfileAction(history)
        )
    },
    fetchSelectedTab(selectedOption) {
        dispatch(
            actions.selectedtabAction(selectedOption)
        )
    },
    clearInput() {
        dispatch(
            actions.clearInputAction()
        )
    },
    // clearCardImage() {
    //     dispatch (
    //         actions.clearCardImageAction()
    //     )
    // }
})

class AuthNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "home",
            pageExpiresIn: "",
            selectedOption: localStorage.getItem("taboption"),
            expiryvalue: "first",
            timeout: 1770000,
            showModal: false,
            open: false,
            isTimedOut: false,
            anchorEl: null,
            anchorE2: null,
            anchorE3: null,
            lastSuccessfulLogin: localStorage.getItem('lastSuccessfulLogin'),
            // cardTypes: localStorage.getItem('cardTypes')

        }

        this.handleActive = this.handleActive.bind(this)
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
    }
    handleActive(e) {
        let _this = this
        const { profileState } = this.props

        this.setState({
            selectedOption: "tab1"
        }, () => {
            localStorage.setItem("taboption", "tab1")
            _this.props.fetchSelectedTab(this.state.selectedOption)
            _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

        })
    }
    handleLogout = () => {
        let redirectUrl = localStorage.getItem('pform') === 'AU' ? 'au' : 'nz'
        localStorage.clear()
        this.props.clearInput()
        // this.props.clearCardImage()
        //this.props.history.push('/logout')
        this.props.history.push(`/${redirectUrl}`)

    }
    _onAction(e) {

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {
        this.setState({ isTimedOut: false })
    }

    _onIdle(e) {
        const isTimedOut = this.state.isTimedOut
        if (isTimedOut === true) {

        } else {
            this.setState({ showModal: true, open: true, })
            this.idleTimer.reset();
        }
    }
    handleClose() {

        this.setState({ showModal: false, open: false, })
    }
    handleProfile(e) {
        let _this = this
        const { profileState } = this.props
        this.setState({
            selectedOption: "tab1"
        }, () => {
            localStorage.setItem("taboption", "tab1")
            _this.props.fetchSelectedTab(this.state.selectedOption)
            _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)
        })

    }

    componentDidMount() {
        this.props.fetchProfileState(this.props.history)
        JSON.parse(localStorage.getItem("expiryTime"))
    }
    componentWillUnmount() {
        localStorage.setItem("comp", "othercomp")
        let expiry = JSON.parse(localStorage.getItem("expiryTime"))
        let expiryTime = new Date(expiry)
        let time = expiryTime.getTime()
        let currentDate = new Date();
        var current1 = currentDate.getTime();

        if (time <= current1) {

            clearInterval(this.Interval)
        }
    }



    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };


    handleClick1 = event => {
        this.setState({ anchorE2: event.currentTarget });
    };

    handleClose1 = () => {
        this.setState({ anchorE2: null });
    };
    handleClose2 = () => {
        this.setState({ anchorEl: null });
    };
    handleClick3 = event => {
        this.setState({ anchorE3: event.currentTarget });
    };
    handleClose3 = () => {
        this.setState({ anchorE3: null });
    };

    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    getLocalTime = (key) => {

        // let local = localStorage.getItem(key)


        // let spiltArray = local.split(" ");

        let local = localStorage.getItem(key);

        if (!local || local === "null" || local === undefined) {
            return "";
        }

        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        // let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }
    getUnLocalTime = (key1) => {

        let local = localStorage.getItem(key1)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        // let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }


    render() {
        var cardTypes = localStorage.getItem('cardTypes')
        const { profileState } = this.props
        const { lastSuccessfulLogin } = this.state


        const { anchorEl, anchorE2, anchorE3 } = this.state;
        return (
            <div className="col-sm-12 m-0 p-0">
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={this.state.timeout} />

                <div className='container p-0' >
                    <nav className="navbar navbar-expand-sm bg-trans navbar-dark p-0" style={{ backgroundColor: 'transparent' }} >
                        <div className="col-md-12 pr-0 ml-1 mt-2 mb-1">
                            <div className="row ">
                                <div className="col-md-6">
                                    <Link to="/home" className="navbar-brand"><img src={logo} alt='' style={{ width: "70%" }} /></Link>
                                </div>
                                <div className="col-md-6 justify-content-end mt-3 m-0 p-0" >
                                    <ul className="nav justify-content-end align-middle" style={{ width: "100%" }}>
                                        <li className="nav-item nav-tab-padding " style={{ width: "auto" }}>
                                            <Link to="/authcontact-us" activeStyle={styles.activeStyle} className="nav-link text-dark">Contact Us</Link>
                                        </li>
                                        <li className="nav-item nav-tab-padding " style={{ width: "auto" }}>
                                            <Link to="/faqs" activeStyle={styles.activeStyle} className="nav-link text-dark">FAQs</Link>
                                        </li>
                                        <li className="nav-item nav-tab-padding" style={{ width: "auto", paddingRight: '0px' }} onClick={this.handleLogout.bind(this)}>
                                            <a className="nav-link text-dark" style={{ cursor: 'pointer' }}>Logout  <img src={imglogout} height="14" style={{ marginLeft: '4px' }} ></img></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>

                <div className="col-md-12" style={{ backgroundColor: '#0190f7', minHeight: '130px' }}>
                    <div className="container  pr-0" style={{ backgroundColor: 'transparent' }}>
                        <div className='row '>
                            <div className='col-sm-3 Copyright pt-3 pb-2'>
                                <div className="col-md-12 d-flex p-0 m-0">
                                    {/* <img src={profileImg} style={{ height: '100px',  marginTop: '10px', marginRight:"10px"}} /> 
                                    <h4 className='text-white   align-self-center'>Siva Prasad</h4></div> */}
                                    {profileState.status === 200 ?
                                        // <figure className="snip1344">
                                        <React.Fragment>
                                            {/* <img src={subha} alt="profile-sample1" className="background" /> */}
                                            {profileState.body.profilePicture !== null ?
                                                <Link to="/manage-my-profile">
                                                    <img src={"data:image/jpeg;base64," + profileState.body.profilePicture.mediaInfo || defaultImage} style={{ height: '85px', width: "85px", marginTop: '10px', marginRight: "10px", borderRadius: "50%" }} alt="profile-sample1" className=".profile-pic " /></Link> :
                                                <img style={{ height: '80px', width: "80px", marginTop: '10px', marginRight: "10px", borderRadius: "50%" }} src={defaultImage} alt="profile-sample1 " className="profile " />}

                                            <h4 className='text-white mt-1  align-self-center'>{(profileState.body.firstName !== "" && profileState.body.firstName !== null) ? profileState.body.firstName + " " + profileState.body.lastName : ""}
                                                {/* <span><img src={locationimg} alt="" />{profileState.body.city}</span> */}
                                            </h4>


                                            {/* <span><img src={locationimg} alt="" />{profileState.body.city}</span> */}
                                        </React.Fragment>
                                        : <div></div>
                                    }
                                </div>
                            </div>
                            <div className='col-sm-9 mt-2  menubig additionallinks align-self-center text-right'>
                                <NavLink to="/home" className="selected ">Home</NavLink>
                                <NavLink to="/card-activity" className=" ">Card Activity</NavLink>
                                <NavLink to="/manage-my-profile" className=" ">My Profile</NavLink>
                                {/* <Link to="/share-funds" className=" ">Share Funds</Link> */}
                                {localStorage.getItem('cardTypes') === 'R' &&
                                    <React.Fragment >
                                        <Button
                                            aria-owns={anchorE2 ? 'simple-menu' : undefined}
                                            aria-haspopup="true"
                                            onClick={this.handleClick1}
                                            style={{ textTransform: 'none', color: '#fff', fontWeight: 'normal' }}
                                        >
                                            <SaveIcon /> Transfer Funds
                                        </Button>
                                        <Menu
                                            id="simple-menu"
                                            anchorEl={anchorE2}
                                            open={Boolean(anchorE2)}
                                            onWheel={this.handleClose1}
                                            onClose={this.handleClose1}
                                        // onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                        >
                                            <NavLink to="/friends&family"> <MenuItem>Card Accounts</MenuItem></NavLink>
                                            <NavLink to="/transfer-history"><MenuItem>Transfer History </MenuItem></NavLink>
                                            <NavLink to="/share-funds"><MenuItem>Share Funds </MenuItem></NavLink>
                                        </Menu>

                                    </React.Fragment>
                                }

                                <Button
                                    aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                                    aria-haspopup="true"
                                    onClick={this.handleClick}
                                    style={{ textTransform: 'none', color: '#fff', fontWeight: 'normal' }}
                                >
                                    <SaveIcon /> Additional Services
                                </Button>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onWheel={this.handleClose2}
                                    onClose={this.handleClose2}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                >
                                    <MenuItem onClick={this.handleClose}> <Link className='text-white' to="/change-password">Change Password </Link></MenuItem>
                                    <MenuItem onClick={this.handleClose}>  <Link className='text-white' to="/change-password">Change Secret Q&A</Link> </MenuItem>
                                    <MenuItem onClick={this.handleClose} > <Link className='text-white' to="/change-pin">Change PIN</Link> </MenuItem>
                                    <MenuItem onClick={this.handleClose} > <Link className='text-white' to="/block-card">Lock Card </Link></MenuItem>
                                    <MenuItem onClick={this.handleClose}> <Link className='text-white' to="/card-preferences">Card Restrictions</Link></MenuItem>
                                    {/* <MenuItem>Logout</MenuItem> */}
                                </Menu>
                                {/* <NavLink to="/load-to-card" className=" ">Load to Card</NavLink> */}
                                {/* HIDE REQUEST CARD FOR NZ */}
                                {localStorage.getItem('pform') === 'AU' &&
                                    <NavLink to="/requestcard" className=" ">Request Card</NavLink>
                                }

                                {localStorage.getItem('mnuMW') === 'true' &&
                                    <React.Fragment>
                                        <Button
                                            aria-owns={anchorE2 ? 'simple-menu' : undefined}
                                            aria-haspopup="true"
                                            onClick={this.handleClick3}
                                            style={{ textTransform: 'none', color: '#fff', fontWeight: 'normal', fontFamily: "archivo", fontSize: "16px" }}
                                        >
                                            <SaveIcon /> Mobile Wallet
                                        </Button>
                                        <Menu
                                            id="simple-menu"
                                            anchorEl={anchorE3}
                                            open={Boolean(anchorE3)}
                                            onWheel={this.handleClose3}
                                            onClose={this.handleClose3}
                                            onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                        >
                                            <NavLink to="/applewallet"> <MenuItem>Apple Wallet</MenuItem></NavLink>
                                            <NavLink to="/googlewallet"><MenuItem>Google Wallet </MenuItem></NavLink>
                                            <NavLink to="/tokens"><MenuItem>View Tokens  </MenuItem></NavLink>
                                            <NavLink to="/walletfaq"><MenuItem> Wallet FAQ's </MenuItem></NavLink>
                                            <NavLink to="/walletterms"><MenuItem> Wallet Terms </MenuItem></NavLink>
                                        </Menu>
                                    </React.Fragment>
                                }

                            </div>

                        </div>

                    </div>
                </div>


                {
                    this.state.open && <IdleTimeOutModal
                        open={this.state.open}
                        onClose={this.handleClose}
                        handleLogout={this.handleLogout}
                    />
                }
                <div className="col-md-12 mb-4" style={{ backgroundColor: '#F8F8F8' }}>
                    <div className="container " style={{ backgroundColor: '#F8F8F8', height: '64px' }}>
                        <div className="col-sm-12 align-self-center" >
                            <div className="dashboard-well ">
                                <div className="row" >
                                    <div className="col-md-12 pl-0 pr-0 " style={{ marginTop: "10px" }}>
                                        <label style={{ color: '#666' }}><span> <b>Today is: {moment().format('llll')} </b> </span> | <b>Last Successful Login:</b>
                                            {lastSuccessfulLogin !== null && lastSuccessfulLogin !== "null" && lastSuccessfulLogin !== "" &&
                                                <span style={{ color: '#666' }}><b> {this.getLocalTime("lastSuccessfulLogin")}</b> </span>}
                                        </label>
                                    </div>

                                    {/* <div className="col-md-2 text-right" onClick={this.handleLogout.bind(this)}>
                                        <label><i className="fa fa-sign-out" aria-hidden="true"></i>Logout </label>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

// AuthNavbar.defaultProps = {
//     profileState: {
//         status: 400
//     }
// }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthNavbar));


// WEBPACK FOOTER //
// ./src/components/navigation/authnavigation.jsx